module.exports = __webpack_public_path__ + "img/c06_unitpriest_Normal_ua.7a964350.webp";